import {useState} from 'react';
import {Box} from '@mui/material';
import {MoreVert} from '@mui/icons-material';
import {Acrobat, Excel, IconFolder, Word, Qgiszip} from '../../assets';
import '../../assets/styles/uploadDataCenterCard.scss';
export default function UploadDataCenterCard({
  text,
  type = 'folder',
  onClick,
  withImage = true,
  options = [],
  ext,
}) {
  const [openMore, setOpenMore] = useState(false);
  const handleImage = (type) => {
    switch (type) {
      case 'folder':
      case 'fixed_folder':
        return IconFolder;
      case 'file':
        return handleExtension(ext);
      default:
        return;
    }
  };
  const handleExtension = (ext) => {
    switch (ext) {
      case 'pdf':
        return Acrobat;
      case 'doc':
      case 'docx':
        return Word;
      case 'xls':
      case 'xlsx':
        return Excel;
      case 'zip':
        return Qgiszip;
      default:
        return;
    }
  };
  return (
    <Box className='udcc_card_ctr'>
      <Box className='udcc_card_content' onClick={onClick}>
        {withImage && (
          <img
            className='udcc_card_img'
            src={handleImage(type)}
            alt='udcc_card_img'
          />
        )}
        <div className='udcc_card_text'>
          <p className='text_upper'>{text}</p>
        </div>
      </Box>
      <Box className='udcc_card_more'>
        <MoreVert
          htmlColor='#fff'
          onClick={() => setOpenMore((prev) => !prev)}
        />
        {openMore && (
          <Box className='udcc_card_option_more'>
            {options.map((item, index) => (
              <Box
                className='udcc_card_option_more_item'
                key={index}
                onClick={() => {
                  item.onClick();
                  setOpenMore(false);
                }}
              >
                {item.icon && <img src={item.icon} alt='icon' />}
                {item.text}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}
